import { lazy } from "react";

// Critical components that should load instantly for error handling
import PageNotFound from "../pages/Others/PageNotFound";

// All other components are lazy loaded for optimal performance
const SchoolReportPage = lazy(() => import("../pages/Reports/School"));
const SchoolDashboard = lazy(() => import("../pages/Dashboards/School"));
const AllRecoveryRequests = lazy(
  () => import("../pages/AttendaceRecovery/allRequest")
);
const Others = lazy(() => import("../pages/Master/Others"));
const SisImport = lazy(() => import("../pages/Schools/SisImport"));
const SuperAdminDashboard = lazy(
  () => import("../pages/Dashboards/SuperAdmin")
);
const ManageLEAPage = lazy(() => import("../pages/LEAs"));
const AssignmentMaster = lazy(() => import("../pages/Master/Assignment"));
const SuperAdminReport = lazy(() => import("../pages/Reports/SuperAdmin"));
const DistrictAdminDashboard = lazy(
  () => import("../pages/Dashboards/DistrictAdmin")
);
const ManageLEAAdmins = lazy(() => import("../pages/LEAAdmins"));
const ManageSchoolsPage = lazy(() => import("../pages/Schools"));
const DistrictAdminReportPage = lazy(
  () => import("../pages/Reports/DistrictAdmin")
);
const LeavesPage = lazy(() => import("../pages/Leaves"));
const AttendaceRecoveryRequests = lazy(
  () => import("../pages/AttendaceRecovery/requests")
);
const AssignmentsPage = lazy(() => import("../pages/Assignments"));
const Materials = lazy(() => import("../pages/Assignments/materials"));
const AttendaceRecoveryManualForm = lazy(
  () => import("../pages/Leaves/manualForm")
);
const ClerkReportPage = lazy(() => import("../pages/Reports/Clerk"));
const RoastInfoScreen = lazy(() => import("../pages/Roaster"));

// Export all components for use in route definitions
export const Components = {
  // Common
  PageNotFound,

  // Dashboards
  SuperAdminDashboard,
  DistrictAdminDashboard,
  SchoolDashboard,

  // Management Pages
  ManageLEAPage,
  ManageLEAAdmins,
  ManageSchoolsPage,

  // Masters
  AssignmentMaster,
  Others,

  // Reports
  SuperAdminReport,
  DistrictAdminReportPage,
  SchoolReportPage,
  ClerkReportPage,

  // Leaves & Recovery
  LeavesPage,
  AttendaceRecoveryRequests,
  AttendaceRecoveryManualForm,
  AllRecoveryRequests,

  // Assignments & Materials
  AssignmentsPage,
  Materials,

  // Others
  RoastInfoScreen,
  SisImport,
};

// Role-based initial paths
export const roleInitialPaths: Record<string, string> = {
  Super_Admin: "/dashboard",
  LEA_Admin: "/dashboard",
  School_Admin: "/dashboard",
  Parent: "/attendance-recovery/list",
  Teacher: "/recovery-requests",
  Student: "/assignments",
  AttandanceCoordinator: "/recovery-requests",
  Clerk: "/attendance-recovery-manual-form",
};
